import TUIIconStorylands from '@images/precincts/TUI-Icon-Storylands.svg'
import TUIIconSkillsbank from '@images/precincts/TUI-Icon-Skillsbank.svg'
import TUIIconReadingReggieWave1 from '@images/precincts/TUI-Icon-Reading-Reggie-Wave.png'
import TUIIconSpellingREX from '@images/precincts/TUI-Icon-Spelling-REX.svg'
import TUIIconReadingReggieWave from '@images/precincts/TUI-Icon-Reading-Reggie-Wave.png'
import { service } from '@ember/service'
import Component from '@glimmer/component'
import type { IntlService } from 'ember-intl'
import { Precinct } from 'teacher-ui-client/utils/precincts'
import { UnderlineTabButton } from 'teacher-ui-client/components/underline-tab/button'
import { on } from '@ember/modifier'
import { t } from 'ember-intl'
import { fn } from '@ember/helper'
import type { ThemeKeys } from 'teacher-ui-client/utils/themes'

interface Signature {
  Element: HTMLElement
  Args: {
    precincts: Precinct[]
    precinct: Precinct
    themeKey: ThemeKeys
    changeTab: (id: Precinct) => void
  }
}

function precinctLogoPath(precinct: Precinct) {
  switch (precinct) {
    case Precinct.REX_READING:
      return TUIIconReadingReggieWave
    case Precinct.REX_SPELLING:
      return TUIIconSpellingREX
    case Precinct.RE_READING:
      return TUIIconReadingReggieWave1
    case Precinct.RE_SPELLING:
      return TUIIconSkillsbank
    case Precinct.RE_STORYLANDS:
      return TUIIconStorylands
    default:
      return ''
  }
}

export class PrecinctTabs extends Component<Signature> {
  @service intl!: IntlService

  get precinctsTabs() {
    return this.args.precincts.map((precinct) => {
      return {
        id: precinct,
        name: this.intl.t(`precinct.name.${precinct}`),
        logoPath: precinctLogoPath(precinct),
        selected: precinct === this.args.precinct,
      }
    })
  }

  <template>
    <nav class="flex gap-8" role="tablist" ...attributes>
      {{#each this.precinctsTabs as |precinctTab|}}
        <UnderlineTabButton
          data-test-precinct-tab={{precinctTab.id}}
          @active={{precinctTab.selected}}
          @themeKey={{@themeKey}}
          class="grow"
          {{on "click" (fn @changeTab precinctTab.id)}}
        >
          <img
            alt={{t "precinct.imageAlt" precinctName=precinctTab.name}}
            class="mx-auto h-12"
            src={{precinctTab.logoPath}}
          />
          <span class="mt-1">{{precinctTab.name}}</span>
        </UnderlineTabButton>
      {{/each}}
    </nav>
  </template>
}

export default PrecinctTabs
